import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { CurveService } from 'src/app/shared/curve-service/curve.service';
import { LoginService } from 'src/app/shared/user-login/login.service';

@Component({
    selector: 'app-view-latest-graph',
    templateUrl: './view-latest-graph.component.html',
    styleUrls: ['./view-latest-graph.component.css'],
    standalone: false
})
export class ViewLatestGraphComponent implements OnInit {

  role: string
  serverErrorMessages: string
  thermalValues: {}
  dataPoints: {}
  temperatures: []
  timeArray: []
  derivatives: {}
  firstDerivative: []
  loading: boolean = true;
  graphDetails;
  curveData;

  constructor(private loginService: LoginService, private router: Router, private curveService: CurveService) { }

  ngOnInit(): void {
    if (this.loginService.shouldBlock()) {
      alert('Low Balance! Redirecting...');
      this.router.navigateByUrl('/home');
    }
    if(this.loginService.isLoggedIn()){
      this.loginService.getUserProfile().subscribe(
        res => {
          this.role = res['user'].role.toString().toUpperCase();
         //console.log('User', this.role);
          this.getLatestCurveData();
        },
        err => {
         //console.log('Didnt get logged in user', err);
          this.serverErrorMessages = err.error.message;
        }
      )
    }
    else{
      alert('PLEASE LOGIN');
      this.router.navigateByUrl('/signin');
    }
  }

  getLatestCurveData(){
    this.curveService.getCurveData().subscribe(
      res => {
        this.curveData = res['curveDatas'][0]
       //console.log('Got curve data', this.curveData);
        this.curveService.getCurveDataById({curveId: this.curveData['_id']}).subscribe(res=>{
          ////console.log('got curve details', res);
          this.graphDetails = res['curveData'];
         //console.log(this.graphDetails)
        },
        err => {
         //console.log('got error', err)
        })
        this.loading = false;
      },
      err => {
       //console.log('error getting curve data', err)
      }
    )
  }

  sendCurveDataToAnalyser(){
    this.curveService.changeCurve({dataPoints: this.graphDetails.dataPoints, thermalValues: this.graphDetails.thermalValues, derivatives:this.graphDetails.refinedDerivatives})
    this.router.navigateByUrl('analyze-curve');
  }
}
